import { Token } from "../Components/interface";

export const folderUrl = "/3d-assets/";
export const apiUrl = process.env.REACT_APP_DOMAIN_URL;
export const roleConfig = [
  {
    name: "trainee",
    color: "#ffffff",
  },
  {
    name: "junior",
    color: "#9c2f31",
  },
  {
    name: "senior",
    color: "#32CD32",
  },
  {
    name: "commander",
    color: "#800080",
  },
  {
    name: "captain",
    color: "#FFD700",
  },
];
export const TOKENS: Record<string, Token> = {
  WBTC: {
    name: "WBTC",
    address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
    decimals: 8,
  },
  WETH: {
    name: "WETH",
    address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    decimals: 18,
  },
  DAI: {
    name: "DAI",
    address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    decimals: 18,
  },
  USDC: {
    name: "USDC",
    address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    decimals: 6,
  },
  USDT: {
    name: "USDT",
    address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    decimals: 6,
  },
  UNI: {
    name: "UNI",
    address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
    decimals: 18,
  },
  LINK: {
    name: "LINK",
    address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
    decimals: 18,
  },
};
export const searchParamsAPI = ["sort", "category", "chains", "marketplace"];
export type searchParamsType = "sort" | "category" | "chains" | "marketplace";
